import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { setGuestViewChatPropsResolver } from './lazy-route-props'

export async function guestViewChatBeforeEnter (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> {
  const { guestViewChatPropsFn } = await import('./guestViewChatPropsFn')
  setGuestViewChatPropsResolver(guestViewChatPropsFn)
  next()
}
